module.exports = __webpack_public_path__ + "img/1440.c0f678e7.jpg";